<script setup lang="ts">
type Props = {
  selectedAutocompleteText: string | null
}
type Emits = {
  (e: 'onClickEdit'): void
}

defineProps<Props>()
defineEmits<Emits>()
</script>

<template>
  <div class="search-selected">
    <div class="search-selected__container">
      <div class="search-selected__text">
        {{ selectedAutocompleteText }}
      </div>
    </div>

    <the-button
      font="sm"
      size="xs"
      variant="transparent"
      :ripple="false"
      class="search-selected__edit-btn"
      @click="$emit('onClickEdit')"
    >
      Редактировать адрес
    </the-button>
  </div>
</template>

<style scoped lang="scss">
.search-selected {
  &__text {
    font-size: 14px;
    font-weight: 800;
    line-height: 18px;
  }

  &__container {
    max-height: 54px;
    overflow: auto;
  }

  &__edit-btn {
    min-height: unset;
    padding: 0;
    margin-top: 6px;
    background-color: transparent !important;
  }
}
</style>
